/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1PersonIdBasicDataMutationRequest,
  PutApiV1PersonIdBasicDataMutationResponse,
  PutApiV1PersonIdBasicDataPathParams,
  PutApiV1PersonIdBasicData400,
  PutApiV1PersonIdBasicData401,
  PutApiV1PersonIdBasicData404,
  PutApiV1PersonIdBasicData409,
  PutApiV1PersonIdBasicData500,
} from "../../types/personRegisterController/PutApiV1PersonIdBasicData.ts";

function getPutApiV1PersonIdBasicDataUrl(
  id: PutApiV1PersonIdBasicDataPathParams["id"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/person/${id}/basic-data` as const,
  };
  return res;
}

/**
 * @description Atualiza parcialmente os dados básicos de uma pessoa. Apenas os campos informados serão alterados. **(Requer Authorization para autenticação)**
 * @summary Atualizar dados básicos (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/basic-data}
 */
export async function putApiV1PersonIdBasicData(
  id: PutApiV1PersonIdBasicDataPathParams["id"],
  data?: PutApiV1PersonIdBasicDataMutationRequest,
  config: Partial<RequestConfig<PutApiV1PersonIdBasicDataMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1PersonIdBasicDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdBasicData400
      | PutApiV1PersonIdBasicData401
      | PutApiV1PersonIdBasicData404
      | PutApiV1PersonIdBasicData409
      | PutApiV1PersonIdBasicData500
    >,
    PutApiV1PersonIdBasicDataMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1PersonIdBasicDataUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
